




import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class SignUpForOnlineCoaching extends Vue {
  public static navButtonClasses: string[] = ["signup-online-coaching"];
  public static navButtonLabel: () => string = () => "Sign up for details and a direct link to our online coaching sessions.";
}
